$(function () {

	$('.list-view').each(function() {

		// Vars
		var $form = $(this).find('form'),
			$actionsButton = $form.find('#perform-actions'),
			$search = $form.find('.list-view-search input');

		// Prevent submitting with enter
		$(document).on('keypress', $form, function(event) {
		    if (event.which === 13) {
				if ($search.length && $search.attr('data-url')) window.location.href = $search.attr('data-url') + $search.val();
		    	return false;
		    }
		});

		// Checkboxes
		$form.find('th :checkbox').change(function() {
			$form.find('td :checkbox').prop('checked', $(this).prop('checked'));
			update();
		});
		$form.find('td :checkbox').change(function() {
			$form.find('th :checkbox').prop('checked', $form.find('td :checkbox:checked').length === $form.find('td :checkbox').length);
			update();
		});

		// Actions
		function update() {
			var nothingChecked = !!!$form.find('td :checkbox:checked').length;
			$actionsButton.prop('disabled', nothingChecked);
			$form[nothingChecked ? 'removeClass' : 'addClass']('has-checked');
			$form.find(':checkbox').each(function() {
				$(this).parents('tr')[$(this).is(':checked') ? 'addClass' : 'removeClass']('checked');
			});
		}
		update();

		// Perform action
		$form.find('button[name="bulk_action"]').click(performAction);

		// Perform action
		function performAction() {
			var confirmMessage = $(this).attr('data-action-confirm');
			if (!confirm(confirmMessage)) return false;
		}

		// Expandable
		$form.find('tr.has-children[data-id] .expandable').on('click', function() {
			var $tr = $(this).parents('tr');
			$tr.toggleClass('open');
			$form.find('tr[data-parent-id="' + $tr.attr('data-id') + '"]')[$tr.hasClass('open') ? 'removeClass' : 'addClass']('d-none');
			if (!$tr.hasClass('open')) {
				$form.find('tr[data-parents*="' + $tr.attr('data-id') + '"]').addClass('d-none').removeClass('open');
			}
		});

	});

});